import { Component } from '@theme/component';
import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays and updates a product's badges / tags.
 * This component listens for variant update events.
 * It handles badges updates from Variant picker (product page)
 */
class ProductBadgeComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    
    const target = this.closest('.shopify-section');
    if (!target) return;
    target.addEventListener(ThemeEvents.variantUpdate, this.updateBadges);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    const target = this.closest('.shopify-section');
    if (!target) return;
    target.removeEventListener(ThemeEvents.variantUpdate, this.updateBadges);
  }

  /**
   * Updates badges.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateBadges = (event) => {            
    if (event.detail.resource) {
      const variantId = event.detail.resource.id || '';
      
      if (!variantId) return;

      const variantSelector = event.detail.data.html.querySelector(
        `input[type="radio"][data-variant-id="${variantId}"]`
      );
      
      if (variantSelector) {
        const isNew = variantSelector.getAttribute('data-badge-new') === 'true';
        const isClearance = variantSelector.getAttribute('data-badge-clearance') === 'true';
        
        const price = event.detail.resource.price;
        const compareAtPrice = event.detail.resource.compare_at_price;
        const hasDiscount = compareAtPrice > price;
                
        let discountText = '';
        if (hasDiscount) {
           const discount = Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
           discountText = `-${discount}%`;
        }

        const { mediaGalleryBadge } = this.refs;
        
        if (mediaGalleryBadge) {
          const newBadge = mediaGalleryBadge.querySelector('.badge--new');
          const saleBadge = mediaGalleryBadge.querySelector('.badge--sale');

          // Clearance (Always shows Sale % if discounted)
          if (isClearance && hasDiscount) {
             if (newBadge) newBadge.classList.add('hidden');
             if (saleBadge) {
               saleBadge.textContent = discountText;
               saleBadge.classList.remove('hidden');
             }
          } 

          // New (Shows New badge if not Clearance)
          else if (isNew) {
             if (saleBadge) saleBadge.classList.add('hidden');
             if (newBadge) newBadge.classList.remove('hidden');
          } 

          // Regular Sale (Shows Sale % if not New)
          else if (hasDiscount) {
             if (newBadge) newBadge.classList.add('hidden');
             if (saleBadge) {
               saleBadge.textContent = discountText;
               saleBadge.classList.remove('hidden');
             }
          } 
          // No badges
          else {
             if (newBadge) newBadge.classList.add('hidden');
             if (saleBadge) saleBadge.classList.add('hidden');
          }
        }       
      }
    }
  };
}

if (!customElements.get('product-badge-component')) {
  customElements.define('product-badge-component', ProductBadgeComponent);
}